import React from 'react';
import { Card, Typography, Space } from 'antd';
import { ItemsWrapper, Wrapper } from './styles';
import { StyledParagraph } from '../CustomAntdComponents/Typography';
import { formatNumberAsCurrency } from '../../utils/helpers';
import { useRoadSearchStore } from '../../store/roadSearch/roadSearchStore';
import { calculateTotalFare } from '../AvailableBuses/helper';
import { GiveMeSpace } from '../CustomAntdComponents/Utitlities';
import translations from './translations';
import { useI18nContext } from '../../utils/I18n';

const { Paragraph } = Typography;

function RoadPaymentSummary() {
  const {
    state: { t },
  } = useI18nContext();
  const {
    selectedResult,
    selectedBus,
  } = useRoadSearchStore();

  const totalFare = calculateTotalFare(selectedBus ? selectedBus.PassengerFares : []);

  return (
    <Wrapper>
      <Space direction="vertical" size="small">
        <Paragraph strong>Summary</Paragraph>
        <GiveMeSpace size="small" />
        <Card>
          <ItemsWrapper>
            <StyledParagraph color="secondary" size="small" strong>
              {t(translations).ticketAmount}
            </StyledParagraph>

            <StyledParagraph strong>
              {formatNumberAsCurrency(totalFare.ticketAmount, selectedResult?.Currency)}
            </StyledParagraph>
          </ItemsWrapper>

          <ItemsWrapper>
            <StyledParagraph color="secondary" size="small" strong>
              Charges
            </StyledParagraph>

            <StyledParagraph strong>
              {formatNumberAsCurrency(totalFare.totalCharges, selectedResult?.Currency)}
            </StyledParagraph>
          </ItemsWrapper>
        </Card>

        <Card size="small">
          <ItemsWrapper>
            <StyledParagraph color="primary" size="small" strong>
              Total Amount
            </StyledParagraph>

            <StyledParagraph strong size="medium">
              {formatNumberAsCurrency(totalFare.totalAmount, selectedResult?.Currency)}
            </StyledParagraph>
          </ItemsWrapper>
        </Card>
      </Space>
    </Wrapper>
  );
}

export default RoadPaymentSummary;
